import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import Text from '@/components/common/Text';
import Box from '@/components/common/Box';
import { getUserDetail } from '@/apis/admin';
import { QUERY_KEY } from '@/constants/queryKey';
import { ROUTER } from '@/constants/constants';
import UserInfoCard from '@/components/admin/UserDetail/UserInfoCard';
import ActionsPanel from '@/components/admin/UserDetail/ActionsPanel';
import PaymentEventLogSection from '@/components/admin/MonthlyBillDetail/PaymentEventLogSection';
import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

const AdminUserDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const userId = id ? parseInt(id) : 0;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QUERY_KEY.ADMIN.USER_DETAIL, userId],
    queryFn: () => getUserDetail(userId),
    enabled: userId > 0,
  });

  const handleBack = () => {
    navigate(ROUTER.ADMIN.USER_MANAGE);
  };

  if (isLoading) {
    return (
      <Box title='사용자 상세' onClickBack={handleBack}>
        <Text>로딩 중...</Text>
      </Box>
    );
  }

  if (isError || !data?.data) {
    return (
      <Box title='사용자 상세' onClickBack={handleBack}>
        <ErrorText>
          오류가 발생했습니다:{' '}
          {error instanceof Error ? error.message : '알 수 없는 오류'}
        </ErrorText>
      </Box>
    );
  }

  const user = data.data;

  return (
    <Box title={`${user.company} (ID: ${user.id})`} onClickBack={handleBack}>
      <Container>
        <UserInfoCard user={user} />
        {user.recent_payment_events && user.recent_payment_events.length > 0 && (
          <PaymentEventLogSection
            events={user.recent_payment_events}
            title='최근 결제 이력'
          />
        )}
        <ActionsPanel user={user} />
      </Container>
    </Box>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ErrorText = styled(Text)`
  color: ${Theme.colors.WARNING_RED};
`;

export default AdminUserDetailPage;
